var _defs, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n      fill: url(#radial-gradient-7);\r\n      }\r\n\r\n      .cls-2 {\r\n      fill: url(#radial-gradient-5);\r\n      }\r\n\r\n      .cls-3 {\r\n      fill: url(#radial-gradient-4);\r\n      }\r\n\r\n      .cls-4 {\r\n      fill: url(#radial-gradient-6);\r\n      }\r\n\r\n      .cls-5 {\r\n      fill: url(#radial-gradient);\r\n      }\r\n\r\n      .cls-6 {\r\n      fill: #621933;\r\n      }\r\n\r\n      .cls-7 {\r\n      fill: url(#radial-gradient-2);\r\n      }\r\n\r\n      .cls-8 {\r\n      fill: url(#radial-gradient-3);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 127.92,
    cy: 23.85,
    fx: 127.92,
    fy: 23.85,
    r: 21.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77bd48"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 178.43,
    cy: 47.65,
    fx: 178.43,
    fy: 47.65,
    r: 21.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9a628"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 76.83,
    cy: 47.65,
    fx: 76.83,
    fy: 47.65,
    r: 21.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39a174"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 51.28,
    cy: 95.04,
    fx: 51.28,
    fy: 95.04,
    r: 21.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c80c1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 205.03,
    cy: 95.04,
    fx: 205.03,
    fy: 95.04,
    r: 21.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4c3c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 192.07,
    cy: 142.43,
    fx: 192.07,
    fy: 142.43,
    r: 21.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf0d4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 63.38,
    cy: 142.43,
    fx: 63.38,
    fy: 142.43,
    r: 21.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25539a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m215.95,127.51c-3.86-1.64-7.85-3.62-12.03-5.04-8.36-2.83-16.94-4.47-25.86-3.82-11.71.86-21.73,5.59-30.51,13.18-1.89,1.64-3.64,3.44-5.38,5.25-.92.96-1.75,2.05-2.47,3.17-2.23,3.48-1.36,5.15,2.72,5.26,1.97.05,3.94-.05,5.91-.05,6.02,0,11.73,1.38,17.08,4.1,6.43,3.28,10.91,8.3,12.99,15.31.13.43.21.87.27,1.31.02.16-.07.34-.14.65-.21-.1-.49-.14-.55-.28-3.22-7.07-9.01-10.85-16.23-12.95-5.03-1.47-10.13-2.27-15.36-2.14-10.72.26-17.35,5.62-20.02,16.03-1.66,6.46-1.65,12.96-.24,19.42.62,2.82.65,5.46-.52,8.1-1.74,3.92-3.45,7.85-5.22,11.76-.35.78-.91,1.48-1.56,2.52-1.99-3.13-2.75-6.33-3.46-9.48-2.3-10.21-3.37-20.51-1.23-30.89,1.61-7.81,4.71-15,9.29-21.55,2.41-3.44,4.93-6.85,6.96-10.51,1.12-2.03,1.85-4.55,1.88-6.86.13-9.45.98-18.76,3.65-27.86.95-3.24.91-6.58.19-9.85-2.22-9.98-1.18-19.55,3.21-28.79,3.19-6.72,5.12-13.75,4.55-21.29-.03-.34.1-.69.32-1.03,1.94,5.07,2.9,10.21.85,15.48-1.49,3.83-3.23,7.57-4.71,11.41-1.71,4.43-2.33,9-1.12,13.69.2.78.42,1.56.73,2.29,1.6,3.68,3.76,4.44,7.26,2.52,4.01-2.19,6.77-5.61,8.64-9.64,1.58-3.39,2.74-6.98,4.04-10.5.39-1.06.63-2.17,1.14-3.2.87,6.81-.55,13.15-4.26,18.85-1.84,2.84-4.1,5.42-6.3,8.01-4.13,4.86-8.23,9.74-10.03,16.03-1.72,6.01-2.17,12.15-1.37,18.35.33,2.55,1.2,3.05,3.37,1.62,3.8-2.51,7.49-5.22,11.11-7.99,6.26-4.79,12.51-9.62,17.27-16.02,5.44-7.32,8.98-15.44,10.31-24.49.04-.26.08-.54.17-.78.06-.15.21-.26.73-.85.22,1.74.53,3.06.52,4.39-.03,8.86-2.66,16.93-7.68,24.19-1.83,2.64-4.06,5-6.07,7.52-.64.8-1.17,1.68-2.08,3.02,1.68.08,2.79.21,3.89.17,7.34-.27,14.68-.68,21.96.77,6.09,1.21,11.99,2.97,17.41,6.08,3.17,1.82,4.76,3.35,5.96,5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m93.43,253.28c2.71-6.89,8.37-10.83,14.17-14.71-10.83,1.22-21.88-.61-32.28,3.62-5.95,2.42-11.59,5.22-15.81,10.27-.2.24-.54.35-1.14.72.75-3.79,2.66-6.39,5.4-8.38,2.1-1.52,4.36-2.81,6.51-4.27.92-.62,1.72-1.42,2.55-2.11-2.08-3.03-12.12-4.16-19.61-2.48-5.39,1.21-7.2,2.53-16.2,11.47.66-1.21,1.29-2.43,1.98-3.61.81-1.39,1.77-2.7,2.48-4.14.35-.71.67-1.95.31-2.36-.43-.51-1.67-.73-2.41-.52-2.49.71-4.91,1.63-7.34,2.53-1.56.58-3.09,1.26-4.77,1.62,3.2-2.82,6.7-5.1,10.69-6.59,5.78-2.17,11.84-2.75,17.94-2.98,8.41-.31,16.84-.3,25.23-.81,5.07-.31,10.16-1.05,15.12-2.14,10.41-2.3,18.26-8.4,23.88-17.37,5.39-8.61,8.97-17.89,10.22-28.02.62-5.02.56-10.02-.82-14.92-.55-1.97-.25-3.67.71-5.38,1.61-2.83,3.47-5.4,6.67-6.95.38.58.79,1.04,1.03,1.57,3.47,7.72,5.1,15.82,4.87,24.28-.36,12.82-2.97,25.06-9.78,36.13-4.13,6.72-5.93,13.94-5.2,21.8.08.88.01,1.77.01,2.69-13.72-3.02-24.79,1.74-34.43,11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m39.94,127.96c2.03-3.74,5.42-5.84,9.11-7.51,9.14-4.14,18.77-5.79,28.76-5.45,2.6.09,5.19.2,7.78.29.96.03,1.92,0,2.87,0,.14-.22.28-.44.42-.66-.81-1.08-1.55-2.24-2.46-3.23-4.95-5.41-9-11.35-11.16-18.45-1.31-4.31-2.16-8.69-1.97-13.21.05-1.12.28-2.23.87-3.39.16.28.42.54.46.83,2.11,14.1,8.81,25.62,19.78,34.6,5.68,4.64,11.54,9.07,17.46,13.41,3.78,2.77,4.79,2.24,5.12-2.37.82-11.26-1.58-21.51-9.41-30.11-2.53-2.78-4.93-5.69-7.2-8.67-4.65-6.11-6.38-13.07-5.34-20.8.33,1.18.55,2.41,1.01,3.54,1.71,4.21,3.31,8.49,5.33,12.56,1.57,3.16,4.16,5.59,7.32,7.3,3.41,1.84,5.6,1.16,7.12-2.38,1.99-4.65,1.9-9.46.33-14.18-1.12-3.39-2.47-6.73-4.03-9.94-3.03-6.27-3.11-12.54-.44-19.41.15.92.34,1.45.31,1.97-.48,6.88,1.23,13.3,3.96,19.53,2.16,4.92,4.43,9.86,4.61,15.33.13,4,.3,8.11-.43,12.01-1.07,5.71-.87,11.17.77,16.7,2.01,6.75,2.49,13.73,2.5,20.72,0,3.91.31,7.67,2.51,11.09.37.57.32,1.81-.06,2.4-2.63,4.04-5.4,7.99-8.27,12.18-4.42-1.28-9.03-1.42-13.67-.98-5.39.51-10.57,1.81-15.49,4.11-4.99,2.34-8.49,6.14-11.17,11.09.05-.62-.01-1.27.16-1.85,2.57-8.68,8.56-14.03,16.81-17.13,5.28-1.98,10.75-2.65,16.36-2.43,1.16.04,2.33.11,3.49.03,3.28-.23,4.07-1.73,2.42-4.64-.57-1.01-1.25-1.97-2.02-2.84-10.31-11.61-22.87-18.99-38.68-19.43-12.11-.34-23.6,2.56-34.26,8.44-.54.3-1.07.63-1.6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m182.97,238.35c.82.71,1.61,1.51,2.52,2.13,2.14,1.46,4.41,2.75,6.52,4.26,2.76,1.98,4.67,4.6,5.44,8.19-.41-.11-.7-.09-.83-.23-8.24-9.02-18.9-12.56-30.68-13.44-4.28-.32-8.59-.26-12.89-.44-1.57-.07-3.13-.33-4.87-.27,5.88,3.85,11.54,7.85,14.23,14.84-8.76-9.17-19.43-13.05-32.21-11.94-2.16-10.24,1.8-18.85,7.21-27.29.47.39.99.7,1.34,1.15,6.84,8.66,16.06,13.19,26.77,14.25,10.5,1.03,21.08,1.22,31.63,1.68,6.99.31,13.96.6,20.63,3.06,4.04,1.49,7.59,3.77,10.94,6.39-.07.17-.15.34-.22.5-1.2-.48-2.4-.98-3.61-1.43-2.68-1-5.33-2.1-8.07-2.9-.86-.25-1.96.31-2.96.5.22.9.26,1.91.69,2.69,1.37,2.46,2.88,4.83,4.08,7.53-6.36-8.99-14.82-13.25-25.8-12.34-6.64.55-8.15.93-9.86,3.1Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 127.92,
    cy: 23.85,
    r: 21.24
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 178.43,
    cy: 47.65,
    r: 21.24
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 76.83,
    cy: 47.65,
    r: 21.24
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 51.28,
    cy: 95.04,
    r: 21.24
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 205.03,
    cy: 95.04,
    r: 21.24
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.07,
    cy: 142.43,
    r: 21.24
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 63.38,
    cy: 142.43,
    r: 21.24
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.287315573aae787564b4b73ca1748a7e.svg";
export { ForwardRef as ReactComponent };